/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Harden_Output6Inputs */

const en_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly report`)
};

const ar_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقرير شهري`)
};

const bn_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাসিক রিপোর্ট`)
};

const de_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatsbericht`)
};

const es_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe mensual`)
};

const fr_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport mensuel`)
};

const pt_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatório mensal`)
};

const zh_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月报`)
};

const tr_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık rapor`)
};

const ru_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месячный отчёт`)
};

const pl_svc_retainer_harden_output6 = /** @type {(inputs: Svc_Retainer_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raport miesięczny`)
};

/**
* | output |
* | --- |
* | "Monthly report" |
*
* @param {Svc_Retainer_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_harden_output6 = /** @type {((inputs?: Svc_Retainer_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_harden_output6(inputs)
	if (locale === "bn") return bn_svc_retainer_harden_output6(inputs)
	if (locale === "de") return de_svc_retainer_harden_output6(inputs)
	if (locale === "es") return es_svc_retainer_harden_output6(inputs)
	if (locale === "fr") return fr_svc_retainer_harden_output6(inputs)
	if (locale === "pt") return pt_svc_retainer_harden_output6(inputs)
	if (locale === "zh") return zh_svc_retainer_harden_output6(inputs)
	if (locale === "tr") return tr_svc_retainer_harden_output6(inputs)
	if (locale === "ru") return ru_svc_retainer_harden_output6(inputs)
	if (locale === "pl") return pl_svc_retainer_harden_output6(inputs)
	return en_svc_retainer_harden_output6(inputs)
});
export { svc_retainer_harden_output6 as "svc_retainer_HARDEN_output" }